import React, { useEffect, useState } from "react";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import { parse, format, isPast } from "date-fns";

const CardTop = (props) => {
  const {
    card,
    svgObjects,
    isRoomOrApartment,
    handleFavoriteClick,
    favouriteClassname,
    localStorageFavouriteObject,
  } = props;

  const { translate } = tampuuriWindowObject();

  const notFavorite = (card) => {
    if (!card?.favorite || parseInt(card?.favorite) === 0) {
      return true;
    }
    return false;
  };

  const renderFreeDate = (card) => {
    // Default case
    let result = translate("Heti vapaa");

    if (!card?.free_date) {
      // Missing data so return early
      return result;
    }

    // Has free_date, check if the date has passed
    const [day, month, year] = card?.free_date?.split(".").map(Number) ?? [];

    if (!day || !month || !year) {
      // Some mistake
      return result;
    }

    const freeDate = new Date(year, month - 1, day);

    if (!freeDate) {
      // Some mistake
      return result;
    }

    const parsedDate = parse(card?.free_date, "d.M.yyyy", new Date());

    if (!isPast(parsedDate)) {
      // Not in the past --> In the future
      const formattedDate = format(parsedDate, "d.M.yyyy");
      result = translate("Vapautuu") + " " + formattedDate;
    }
    // Apartment is already free
    return result;
  };

  return (
    <>
      {notFavorite(card) == false && ( //Favorite
        <>
          <div className="popularity-label">{translate("Suosikkikohde")}</div>

          {card?.available_count > 0 && ( //And available aparmtents --> use vacancy-label-second
            <div className="vacancy-label-second">
              {translate("Asuntoja vapaana")}
            </div>
          )}

          {isRoomOrApartment(card) && ( //Rendering favorite --> Use vacancy-label-second
            <div className="vacancy-label-second">{renderFreeDate(card)}</div>
          )}
        </>
      )}

      {notFavorite(card) && (
        <>
          {card?.available_count > 0 && ( //Not rendering favorite --> Use main vacancy-label
            <div className="vacancy-label">{translate("Asuntoja vapaana")}</div>
          )}

          {isRoomOrApartment(card) && ( //Not rendering favorite --> Use main vacancy-label
            <div className="vacancy-label">{renderFreeDate(card)}</div>
          )}
        </>
      )}

      {svgObjects?.heart && (
        <div
          data-favourite-object={JSON.stringify(localStorageFavouriteObject)}
          data-add-announcer-message={translate("Lisätty suosikiksi")}
          data-remove-announcer-message={translate("Poistettu suosikeista")}
          onClick={handleFavoriteClick}
          className={"favourite-heart " + favouriteClassname}
          dangerouslySetInnerHTML={{
            __html: svgObjects?.heart,
          }}
        />
      )}
    </>
  );
};

export default CardTop;
